import { render } from "./navigation.vue?vue&type=template&id=464c085e&ts=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__